import { createSlice } from '@reduxjs/toolkit';

const counterSlice = createSlice({
  name: 'counter',
  initialState: {
    value: 1,
    quesCountIndex: 0,
    quesTopicName: "",
  },
  reducers: {
    Nextstep: (state) => {
      state.value += 1;
    },
    Prevstep: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
    setQuesCountIndex: (state, action) => {
      state.quesCountIndex = action.payload;
    },
    setQuesTopicName: (state, action) => {
      state.quesTopicName = action.payload;
    },
  },
});

export const { Nextstep, Prevstep, incrementByAmount, setQuesCountIndex, setQuesTopicName } = counterSlice.actions;
export default counterSlice.reducer;
